module.exports = __webpack_public_path__ + "img/knight3_feature_01.90fa411a.jpg";